var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpRiskit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3368_4515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 0H0V96H96V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1398 74.4C71.0864 75.5085 70.6085 76.5539 69.8051 77.3195C69.0017 78.0852 67.9345 78.5122 66.8248 78.5122C65.715 78.5122 64.6478 78.0852 63.8444 77.3195C63.0411 76.5539 62.5631 75.5085 62.5098 74.4C62.5098 72.02 66.8298 64.28 66.8298 64.28C66.8298 64.28 71.1398 72 71.1398 74.4Z",
    fill: "white",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4899 72.59C33.4365 73.6984 32.9586 74.7439 32.1552 75.5095C31.3518 76.2751 30.2846 76.7022 29.1749 76.7022C28.0651 76.7022 26.9979 76.2751 26.1945 75.5095C25.3912 74.7439 24.9132 73.6984 24.8599 72.59C24.8599 70.21 29.1699 62.47 29.1699 62.47C29.1699 62.47 33.4899 70.21 33.4899 72.59Z",
    fill: "white",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5399 82.2099C53.5399 83.6262 52.9773 84.9844 51.9758 85.9859C50.9744 86.9873 49.6161 87.5499 48.1999 87.5499C46.7836 87.5499 45.4254 86.9873 44.4239 85.9859C43.4225 84.9844 42.8599 83.6262 42.8599 82.2099C42.8599 79.2699 48.1999 69.6899 48.1999 69.6899C48.1999 69.6899 53.5399 79.2699 53.5399 82.2099Z",
    fill: "white",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3602 29.4599C75.8302 29.4599 75.3602 29.81 75.3602 29.81C75.9418 27.9018 76.2218 25.9145 76.1902 23.92C76.1902 15.36 68.8902 8.44995 60.3202 8.44995C56.9055 8.46243 53.5856 9.57386 50.8517 11.6198C48.1178 13.6657 46.1152 16.5374 45.1402 19.81C43.4022 17.8931 41.1245 16.5475 38.607 15.9503C36.0894 15.3531 33.45 15.5322 31.0362 16.4642C28.6224 17.3961 26.5475 19.0372 25.0845 21.1713C23.6215 23.3054 22.839 25.8325 22.8402 28.42L23.0002 31.06C23.0002 31.06 21.7202 30.06 18.5002 30.19C16.8166 30.19 15.1496 30.5216 13.5942 31.1658C12.0388 31.8101 10.6255 32.7544 9.43507 33.9448C8.24462 35.1353 7.30031 36.5486 6.65604 38.104C6.01177 39.6593 5.68018 41.3264 5.68018 43.0099C5.68018 44.6935 6.01177 46.3606 6.65604 47.916C7.30031 49.4713 8.24462 50.8846 9.43507 52.0751C10.6255 53.2655 12.0388 54.2098 13.5942 54.8541C15.1496 55.4984 16.8166 55.83 18.5002 55.83H77.5402C80.9414 55.822 84.2012 54.4681 86.6072 52.064C89.0131 49.6599 90.3696 46.4012 90.3802 43C90.3802 36 85.5202 29.24 78.3602 29.4599Z",
    fill: "white",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3368_4515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpRiskit);
export default __webpack_public_path__ + "static/media/OP_riskit.2f3f7af521fd8f7c4a5812398a331548.svg";
export { ForwardRef as ReactComponent };